<footer class="bg-blue-500 text-white py-4 w-full">
    <div class="container mx-auto flex justify-center items-center">

        <!-- This div contains both the text and the logos, centered horizontally -->
        <div class="flex items-center space-x-6">
         

            <!-- Svelte Logo -->
            <img src="https://creazilla-store.fra1.digitaloceanspaces.com/icons/3254421/svelte-icon-icon-md.png" alt="Svelte Logo" class="h-6">

            <!-- Tailwind Logo -->
            <img src="https://creazilla-store.fra1.digitaloceanspaces.com/icons/3257079/file-type-tailwind-icon-md.png" alt="Tailwind Logo" class="h-6">

   <!-- Netlify Logo -->
            <img src="  https://static-00.iconduck.com/assets.00/netlify-icon-511x512-idkvcd89.png" alt="Tailwind Logo" class="h-6">


          
        </div>

    </div>
</footer>
